var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLRocketLoansRgbHorz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graphics",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 54",
    style: {
      enableBackground: "new 0 0 520 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C8102E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.8,25.7l21.3,27.4h-15.3l-19.5-25.6v25.6h-12.8V0.9h12.8v23.3l18.9-23.3h15.2L190.8,25.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.7,42.4 255.6,42.4 255.6,53.1 217.9,53.1 217.9,0.9 254.4,0.9 254.4,11.6 230.7,11.6 230.7,21.2 252.1,21.2  252.1,31.6 230.7,31.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.8,0.9 260.8,11.6 276.8,11.6 276.8,53.1 289.5,53.1 289.5,11.6 305.3,11.6 305.3,0.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.8,0.9 260.8,11.6 276.8,11.6 276.8,53.1 289.5,53.1 289.5,11.6 305.3,11.6 305.3,0.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.6,33l15.7,20.1H31.6L12.9,27.9v25.2H0.1V0.9h23.5c11.2,0,19,6.9,19,16.9C42.5,24.9,37.9,31.3,30.6,33z M29.8,18 c0-3.9-3.1-6.6-7.5-6.6h-9.4v13.2h9.4C26.8,24.6,29.8,21.9,29.8,18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.2,11.3c9.4,0,16.8,7.2,16.8,17.1c0,7.8-3.9,12.5-9.1,16l7.2,9.6c8.9-6.1,14.5-14.5,14.5-25.6 c0-16.4-13-28.3-29.4-28.3s-29.4,12-29.4,28.3c0,11.1,5.6,19.5,14.5,25.6l7.2-9.6c-5.2-3.5-9.1-8.2-9.1-16 C60.5,18.5,67.8,11.3,77.2,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,38.7l6.7,9.1c-4.9,4.3-10.9,6.2-18.4,6.2c-14.7,0-27.4-10.7-27.4-27.1c0-16,12.6-26.9,27.4-26.9 c7.1,0,13.5,1.8,18.3,5.7l-7,9.5c-2.8-2.2-6.2-3.9-11.3-3.9c-8.1,0-14.6,6.4-14.6,15.9c0,9.3,6.5,15.6,14.8,15.6 C145.2,42.7,148.7,40.9,151.6,38.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356,46.3v6.8h-29.9V0.9h7.6v45.4L356,46.3L356,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,34.6c0-11.2,8.2-19.3,19.5-19.3c11.5,0,19.5,8.1,19.5,19.3c0,11.2-7.9,19.3-19.5,19.3C367.1,53.8,359,45.8,359,34.6z  M390.8,34.6c0-7.6-5.1-12.7-12.4-12.7c-7.2,0-12.3,5.1-12.3,12.7s5.2,12.7,12.3,12.7C385.8,47.3,390.8,42.1,390.8,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.8,16v37.1h-7v-6.5c-2.9,5.1-7.8,7.2-13.5,7.2c-10.4,0-17.9-8-17.9-19.2c0-11.3,7.5-19.3,17.9-19.3 c5.7,0,10.8,2.4,13.5,7.1V16H441.8z M435.2,34.6c0-7.4-5.4-12.8-12.5-12.8s-12,5.1-12,12.9c0,7.6,4.8,12.7,11.9,12.7 C429.8,47.4,435.2,41.9,435.2,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.5,30.7v22.4h-7V32.3c0-6.6-3.2-10.7-9.3-10.7c-6,0-10.2,4.5-10.2,10.8v20.7h-7V16h7v5.3c2.4-3.9,6.9-6,12.4-6 C479.2,15.3,484.5,20.7,484.5,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.3,48.2l4.3-4.4c2.6,2.6,5.9,4.3,10.4,4.3c3.9,0,6.8-1.8,6.8-5.1c0-3.4-2.9-4.5-8.6-6.1c-5.9-1.6-11.2-4.3-11.2-10.8 s5.4-10.7,13.2-10.7c6.2,0,10.4,2.4,12.8,4.9l-4.1,4.4c-2-2-4.9-3.5-8.6-3.5c-4,0-6.5,1.8-6.5,4.8c0,3.1,3.2,4.1,8.2,5.6 c6.6,1.8,11.8,4.3,11.8,11.2c0,6.6-5.4,11.2-13.7,11.2C499.2,53.8,494.8,51.7,491.3,48.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLRocketLoansRgbHorz);
export default __webpack_public_path__ + "static/media/L-RocketLoans-RGB-Horz.a8204c6860bc57ec6c4f68eada899df2.svg";
export { ForwardRef as ReactComponent };